<template>
  <div class="checkout-section">
    <div class="checkout-iframe">
      <iframe v-if="paymentFrame" :src="paymentFrame.url"></iframe>
    </div>

    <div class="checkout-section__footer">
      <NavButton :back="true" text="Back" :class="{ 'btn btn--outline-gray-color btn--outline-gray-color_sm resultCardMapTs': data.brandNameFormatted === Brand.Travelsphere }" :brand="data.brandNameFormatted"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NavButton from './../Components/NavButton.vue';
import {Brand} from './../../../../brand.js';

export default {
  name: 'Payment',

  components: {
    NavButton
  },

  props: {
    brandName: {
      type: String,
      default: ''
    }
  },

  data: function() {
    return {
      Brand
    };
  },

  computed: mapState('checkout', ['paymentFrame', 'quote', 'data']),

  activated() {
    // listen for messages from the iframe
    window.addEventListener('message', this.paymentResponse);
  },

  methods: {
    paymentResponse(evt) {
      // check the message is coming from our page
      // check its got a transaction id
      if (
        !evt ||
        evt.origin !== window.location.origin ||
        !evt.data ||
        typeof evt.data.transactionId === 'undefined'
      ) {
        return;
      }

      // update the quote with the transactionId
      this.$store.commit('checkout/setQuote', evt.data);
      this.$store.commit('checkout/setQuoteDonations');
      this.$store.commit('checkout/setPaymentFrame', null);
      this.$store.dispatch('checkout/paymentStatus');
      this.$store.commit('checkout/nextStep');
    }
  }
};
</script>